import { connect } from 'react-redux'
import * as contractActions from '../ContractsActions'
import * as flashMessageActions from '../../FlashMessage/FlashMessageActions'
import * as appActions from '../../App/AppActions'
import Contracts from './ContractsList'


const mapStateToProps = (state) => ({
    contracts: state.contracts.list,
    contractsLoaded: state.contracts.loaded,
    apiClientLoaded: state.apiClient.loaded,
    createdContract: state.contracts.created,
    newCurrentContract: state.contracts.updated
})

const actions = {
    ...contractActions, 
    ...flashMessageActions,
    ...appActions
}

export default connect(mapStateToProps, actions)(Contracts)


// WEBPACK FOOTER //
// ./src/components/Contracts/List/index.jsx